import React, { useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import Select from 'react-select';
import axios from 'axios';
import { uatabstartOldUrl, currentDateAndTime, decodeData, abstartOldUrl } from '../../Constants/constants';
import { saveAs } from "file-saver";
import { ConfigContext } from '../../Context/ConfigContext';
import { NoRecords } from '../../Components/Shimmer';
import { SubmitButton } from '../../Components/InputElements';
import { useLocation } from 'react-router-dom';
import MainPageLoader from '../../Components/MainPageLoader';

function PayslipsOld(props) {
    const { apiURL, apiHeaderJSON,permissions } = useContext(ConfigContext);
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

    const [loading, setLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [monthOptions, setMonthOptions] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const limitOptions = [10, 25, 50, 100];
    const [rows, setRows] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [pagination, setPagination] = useState({
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false
        });
    const [filterOptions, setFilterOptions] = useState({
        location_options: [],
        department_options: [],
    });
    const [filter, setFilter] = useState({
            keyword: null,
            month: null,
            location_id: null,
            department_id: null,
            publishOrUnpublish: "1",
    });

    // get payslip months
    const getList = () => {
        // console.log("filter?.month", filter?.month);
        // console.log(" pagination",  pagination );

        axios
            .get(`${abstartOldUrl}pages/api/v1/payslip/employees-payslip/list`, {
                params: {
                    limit: pagination?.limit || 10,
                    page: pagination?.page || 1,
                    // keyword: filter?.keyword,
                    // monthYear: filter?.month,
                    // location_id: filter?.location_id,
                    // department_id: filter?.department_id,
                    // publish_status: filter?.publishOrUnpublish,
                    token:"asdf",
                    comp_code: localStorage.getItem("company_code") ,
                    salary_month_year: filter?.month
                },
            })
            .then((response) => {
                const data = response?.data;
                // if (data?.success === true) {
                    console.log(data);
                    setPagination({
                        next: data?.next,
                        prev: data?.prev,
                        page: data?.page || pagination?.page,
                        limit: data?.limit || pagination?.limit,
                        total_records: data?.total_records,
                        total_pages: data?.total_pages,
                        loadingList: false,
                    });
                    console.log("data?.data",data?.data);
                    setRows(data?.data);

                // } else {
                //     if(data?.message === "Month Year is required."){
                //         setRows([]);
                //     }
                //     setPagination({ ...pagination, loadingList: false });
                // }
                setLoading(false);
                setLoadingFilter(false);
            })
            .catch((error)=>{
                setLoading(false);
                setLoadingFilter(false);

            });
    };
    const getEmploymentMasterList = () => {
        const headers = apiHeaderJSON;
        axios
          .get(`${apiURL}Masters/GetEmploymentMasterList`, { headers })
          .then((response) => {
            let data = response.data;
            if (response.data.success === true) {
                data= data?.data;
              setFilterOptions({
                ...filterOptions,
                location_options: data.location_list.map((row) => ({
                  value: row.location_id,
                  label: row.location_title,
                })),
                department_options: data?.department_list.map((row) => ({
                    value: row.department_id,
                    label: row.department_title,
                  })),
              });  
            }
          });
      };
    function getPayslipByMonth() {
        axios.get(`${abstartOldUrl}pages/api/v1/payslip/employees-salary-month-year/list?token=asdf&comp_code=TCO`,)
        .then(async (response) => {
            console.log("getPayslipByMonth ==>", response);
            const {data} = response?.data
            if(Array.isArray(data) && data.length>0){
                setFilter({
                    ...filter,
                    month: data[0]
                })
                const temp = data?.map((val)=>{
                    return {value: val, label: val}
                })
                setIsChanged("1");
                setMonthOptions(temp);
            }
            setLoading(false);          
            setLoadingFilter(false);
        }).catch((error) => {
            setLoading(false);
            setLoadingFilter(false);
            console.log('getPayslipByMonth => ERROR: ', error);
        });
    }

    useEffect(() => {
        setLoading(true);   
        getEmploymentMasterList();
        getPayslipByMonth();
    }, []);

    useEffect(() => {
        if(isChanged){
            // console.log("2",isChanged);
            if(isChanged === '1'){
                setLoadingFilter("1");
                getList();
            } else {
                getList();
            }
            setIsChanged(false);
        }
    }, [isChanged]);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((row) => {
                return row?.emp_code
            }));
        } else {
            setSelectedRows([]);
        }
    };
    const handleCheckboxChange = (employeeData) => {
        const isSelected = selectedRows.some(row => row === employeeData?.emp_code);
        if (isSelected) {
            setSelectedRows(selectedRows.filter(row => row !== employeeData?.emp_code));
        } else {
            setSelectedRows([...selectedRows, employeeData?.emp_code]);
        }
    };    
    console.log("selectedRows",selectedRows);
      
    const downloadOldButton = (row) => {
        setLoadingDownload(row?.emp_code);
        axios.get(`${uatabstartOldUrl}pages/api/v1/payslip/bulk-pdf-zip-Madzipper`, {
            params: {
                token: "654",
                // comp_code: localStorage.getItem("company_code"),
                who_is: "user",
                emp_code: row ? [row?.emp_code] : selectedRows,
                comp_code: localStorage.getItem("company_code"),
                salary_month: filter?.month.split("-")[0],
                salary_year: filter?.month.split("-")[1],
            },
            responseType: 'blob'
        })
        .then((response) => {
            console.log("response", response);
            const blob = new Blob([response.data], { type: 'application/zip' });
            saveAs(blob, "Payslips.zip"); 
            setSelectedRows([]);
            setLoadingFilter(false);
            setLoadingDownload(false);
        })
        .catch((error) => {
            console.error('There was a problem with the download:', error);
            console.log("loadingDownload 2");
            setLoadingFilter(false);
            setLoadingDownload(false);
        });
    };

    const handlePrev = () => {
        if (pagination?.prev === true) {
            setPagination({
                ...pagination,
                page: pagination?.page - 1
            });
            setIsChanged(true);
        }
    }
    const handleNext = () => {
        if (pagination?.next === true) {
            setPagination({
                ...pagination,
                page: pagination?.page + 1
            });
            setIsChanged(true);
        }
    }
    const handleChanged = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value, 10)
        });
        setIsChanged(true);
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value, 10),
                page: 1,
            }
        );
        setIsChanged(true);
    };
    // MainPageLoader used for initial loading
    if (loading) return <MainPageLoader/>;

    return (
        <div class="main-content" >
            <div class="page-content">
                <div className="container-fluid"><br />
                    <PageTitle title={`Old Payslip`} primary={`My Details`} />
                    <div className="card">
                        <div className="card-body">
                            <div className="card-header">
                                <div className="row">
                                    <div className='col-md-3 position-relative mb-5'>
                                        <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                            <label htmlFor="Location" className="form-label" > Select Month </label>
                                            <Select onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                            options={monthOptions}
                                            placeholder={`Select Month`}
                                            value={ filter?.month ? monthOptions.find(option => option.value === filter?.month) : null } />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div><label>Apply Filter</label></div>
                                                <SubmitButton onClick={(e)=>{ setLoadingFilter("1"); getList(); }}
                                                disabled={(!filter?.location_id && !filter?.month && !filter?.department_id) || loadingFilter === "4"} 
                                                loading={loadingFilter==="1"} loadingMessage='Loading' 
                                                buttonName={'Filter'} icon={'ri-filter-3-fill'} type='info' iconSide='left' />
                                            </div>
                                        </div>
                                    </div>
                                    {selectedRows?.length>0 && (
                                        <div className="col-md-3">
                                            <div><label className='noWrap'>Bulk Download</label></div>
                                            <SubmitButton onClick={(e)=>{  setLoadingFilter("4");  downloadOldButton(); }}
                                            disabled={selectedRows?.length === 0}
                                            loading={loadingFilter === "4"} loadingMessage='downloading'
                                            buttonName={'Download'} icon={'ri-download-2-fill'} type='primary' iconSide='left' />   
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                    <table id="example" className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed" style={{ width: '100%' }} aria-describedby="example_info">
                                        <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                            <tr>
                                                {rows?.length > 0 && decodedData?.includes(3)  &&
                                                    (<th style={{ width: '10%' }}>
                                                        <div className="d-flex gap-1 align-items-center justify-content-center">
                                                            <input type="checkbox" className="form-check-input"
                                                                onChange={handleSelectAll}
                                                                disabled={loadingDownload}
                                                                checked={selectedRows.length === rows.length}/>
                                                                Select
                                                            {selectedRows?.length > 0 && ( <span className="text-white">({selectedRows?.length})</span>)}
                                                        </div>
                                                    </th>)
                                                }
                                                <th className='noWrap'>Employee Code</th>
                                                <th className='noWrap'>Employee Name</th>
                                                {decodedData?.includes(3) && ( <th style={{ width: '15%' }} className=' text-center'>Action</th> )}
                                            </tr>
                                        </thead>
                                        {rows?.length === 0 ?
                                            <tbody>
                                                <td colSpan={5}>
                                                    <NoRecords />
                                                </td>
                                            </tbody> :
                                            <tbody>
                                                {rows?.map((row, idx) => (
                                                    <tr key={row.emp_code}>
                                                        { decodedData?.includes(3) && ( 
                                                        <td>
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <input type="checkbox" className="form-check-input"
                                                                onChange={() => handleCheckboxChange(row)}
                                                                disabled={loadingDownload}
                                                                checked={selectedRows.some(val => val === row?.emp_code)}/>
                                                            </div>
                                                        </td>)}
                                                        <td>{row?.emp_code}</td>
                                                        <td>{row?.emp_name}</td>
                                                        {decodedData?.includes(3) && (
                                                        <td className=' text-center'> 
                                                            <SubmitButton onClick={(e)=>{ downloadOldButton(row); }}
                                                            disabled={loadingDownload || selectedRows?.length>0}
                                                            loading={loadingDownload==row?.emp_code} loadingMessage={"Loading"}
                                                            buttonName={'Download'} icon={'ri-download-2-fill'} type='primary' iconSide='left' />
                                                        </td>)}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        }

                                    </table>
                                </div>
                                <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select className="form-select" onChange={(e) => handleChanged(e)}>
                                            {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                            {limitOptions.map((option) => (
                                                <option key={option} value={option}>
                                                    Limit {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                </div>
                            </div>
                        </div>
                        {loadingFilter==="3" && (
                            <div id="myModal" className="modal show" tabIndex={-1} style={{ display: "block",  backgroundColor: "rgba(0, 0, 0, 0.5)", }} aria-labelledby="myModalLabel" aria-hidden="true">
                                <div className=" h-100 d-flex justify-content-center align-items-center mt-3" style={{ width: "100%" }} >
                                    <div className="modal-content" style={{ width: "50%" }}>
                                        <div className="modal-body">
                                            <div className="card-body">
                                                <h3 className={` ${uploadProgress >= 100 ? "text-primary":"text-dark" } `}> {uploadProgress >= 100 ? "Payslips Downloaded Successfully":"Downloading Payslips"}</h3>
                                                <h5 className=" mb-4">
                                                    {uploadProgress < 100 ? (
                                                    <span className="d-flex align-items-center">
                                                        <span class="spinner-border flex-shrink-0" role="status" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "2px", }}>
                                                            <span className="visually-hidden">
                                                                Loading...
                                                            </span>
                                                        </span>
                                                        <span className="flex-grow-1 ms-2">
                                                            {uploadProgress > 85 ? "Almost Completed..." : loadingRows==="1"? "Preparing Data..." : "Processing..."}
                                                        </span>
                                                    </span>
                                                    ) : (
                                                    "Completed"
                                                    )}
                                                </h5>
                                                <div className="progress animated-progress custom-progress progress-label mt-3">
                                                    <div className="progress-bar bg-success" role="progressbar" style={{ width: `${uploadProgress}%` }} aria-valuenow={uploadProgress} aria-valuemin={0} aria-valuemax={100} >
                                                        <div className="label">{uploadProgress}%</div>
                                                    </div>
                                                </div>
                                                {uploadProgress >= 100 &&
                                                    (<div className=' d-flex justify-content-end align-items-center mt-3'>
                                                        <SubmitButton onClick={(e)=>{  setLoadingRows(false); setLoadingDownload(false); setLoadingFilter(false); setUploadProgress(0); setSelectedRows([]); }}
                                                        disabled={uploadProgress < 100} 
                                                        buttonName={'Close'} icon={'ri-close-line'}  type='light' iconSide='left' />
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </div>
    );
}

export default PayslipsOld;
